import { AccessLevels, Privilege, Privileges } from "../types";

interface Args {
  userPrivileges: Privilege[];
  privilege: Privileges;
  accessLevel: AccessLevels;
}

export const checkPrivilege = ({
  userPrivileges,
  privilege,
  accessLevel,
}: Args) => {
  return userPrivileges.some(
    (p) => p.privilege === privilege && p.accessLevel === accessLevel
  );
};

export const camelizeHyphenCaseKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((v) => camelizeHyphenCaseKeys(v));
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        ...(key.includes("-")
          ? {
              [key.replace(/-([a-z])/g, (g) => g[1].toUpperCase())]:
                camelizeHyphenCaseKeys(obj[key]),
            }
          : { [key]: camelizeHyphenCaseKeys(obj[key]) }),
      }),
      {}
    );
  }
  return obj;
};
